import { stringify } from 'qs';
import request from '@/lib/core/request';
import dom from '@/lib/core/dom';
import gon from '@/lib/core/gon';
import api from '@/lib/core/api';

export function login(body, options = {}) {
  return api.post('/api/v1/user/login', body, options);
}

export function logout(params = {}, options = {}) {
  return api.delete('/api/v1/user/logout', {
    ...options,
    params,
  });
}

export function queryCurrentUser(params = {}, options = {}) {
  return api.get('/api/v1/user', {
    ...options,
    params,
  });
}

// 获取APP授权，传入forceScopes（申请权限范围）
// forceScopes: ykb_user_info（用户信息），ykb_divide（定位，导航栏高度，app站点等）
export function getYkbAuthCode(forceScopes) {
  try {
    return new Promise(async (resolve, reject) => {
      if (window.AlipayJSBridge) {
        const { response, error } = await api.get('/cust/papi/ykb_user/jsapi_token', {});

        if (error) {
          resolve({ code: 100, message: `获取JsapiToken失败：${error.message}` })
        }

        const { jsapi_token: jsapiToken, app_id: appId } = response;

        window.AlipayJSBridge.call(
          'getYkbAuthCode',
          {
            appId: appId,
            forceScopes: forceScopes,
            jsapiToken: jsapiToken
          },
          (res) => {
            if (res.code === 0) {
              const authCode = res?.data?.authCode;

              localStorage.setItem('jsapi_token', jsapiToken);
              localStorage.setItem('app_id', appId);
              localStorage.setItem('auth_code', authCode);

              resolve({
                code: res.code,
                jsapiToken: jsapiToken,
                appId: appId,
                authCode: authCode,
              });
            } else {
              resolve({ code: res.code, message: '获取用户授权失败!' })
            }
          }
        );
      } else {
        resolve({ code: 101, message: '未检测到渝快办APP!' })
      }
    });
  } catch (error) {
    return { code: 102, message: error.message };
  }
}


